export const BOTTOM_SHEET_DRAG_ZONE_SELECTOR = '.bottom-sheet-handle, .bottom-sheet-header';

export const BOTTOM_SHEET_CLOSE_HEIGHT_RATIO = 0.25;

export const BOTTOM_SHEET_FLICK_VELOCITY_PX_PER_MS = 0.5;

export const BOTTOM_SHEET_SPRING_BACK_MS = 200;

export const BOTTOM_SHEET_SLIDE_OUT_MS = 200;

export const REDUCED_MOTION_MEDIA_QUERY = '(prefers-reduced-motion: reduce)';
